// Parse (e.g. "/Date(1683267090000)/") to timestamp
export const parseApiDateHelper = (modified?: string) => {
  const match = modified?.match(/\/Date\((\d+)\)\//);
  return match ? parseInt(match[1], 10) : 0;
};
